let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5Kn8Z")).then(() => parcelRequire('7VfNr'));